module.exports = "<div [innerHTML]=\"transform(widget.htmlContentRichText)\"></div>\r\n<!-- <div [innerHTML]=\"widget.htmlContentRichText | keepHtml\"></div> -->\r\n"


//////////////////
// WEBPACK FOOTER
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/graphs/richtext-editor/richtext-editor.component.html
// module id = ../../../../../src/app/shared/components/graphs/richtext-editor/richtext-editor.component.html
// module chunks = main